import {useVideoPlayer} from '../../useVideoPlayer';
import {VideoControlsItem} from '../Item/VideoControlsItem';

import {Icon} from '@components/@icons';
export const VideoPictureInPictureButton = () => {
    const {togglePictureInPicture} = useVideoPlayer();

    const handleTogglePictureInPicture = () => {
        togglePictureInPicture();
    };

    return (
        <VideoControlsItem onClick={handleTogglePictureInPicture}>
            <Icon
                name="pip"
                color="var(--color-icon-player)"
                width={24}
                height={24}
            />
        </VideoControlsItem>
    );
};
